import React, { useEffect, useReducer, useRef, useState } from 'react';
import { ChatscreenFractalTheme } from './chatscreen.styled';
import Input from '../../../../FlyfishComponents/Input';
import {
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import useScreenType from '../../../../Hooks/DeviceType';
import useScreenSize from '../../../../Hooks/DeviceScreenSize';
import Message from './Message';
import FractalResponse from './FractalResponse';
import Trending from './Trending';
const initialState = {
	message: '',
	loader: false,
	responseId: 0,
	conversationId: 0,
	userInput: '',
	chatMessages: [],
};
const reducer = (state, action) => {
	switch (action.type) {
		case 'SUCCESS':
			return {
				...state,
				loader: false,
				responseId: action.messageId,
				conversationId: action.conversationId,
				chatMessages: [...state.chatMessages, ...action.chatMessages],
			};
		case 'FAILED':
			return {
				...state,
				loader: false,
				chatMessages: [...state.chatMessages, ...action.chatMessages],
			};
		case 'LOADING':
			return {
				...state,
				loader: true,
			};
		case 'USER_MESSAGE':
			return {
				...state,
				chatMessages: [
					...state.chatMessages,
					{
						type: 'user',
						message: action.message,
					},
				],
			};

		default:
			return state;
	}
};
export default function ChatscreenFractal({ conversationOpener }) {
	const [state, dispatch] = useReducer(reducer, initialState);
	const [chatInputValue, setChatInputValue] = useState('');
	const deviceType = useScreenType();
	const screenSize = useScreenSize();
	const chatContainerRef = useRef(null);
	const [submitLoader, setSubmitLoader] = useState(false);
	const [formIsActive, setFormIsActive] = useState(false);

	const submitChat = (value?: string, formData?) => {
		let text = value ? value : '';

		if (chatInputValue.length || text) {
			if (!formData) {
				dispatch({
					type: 'USER_MESSAGE',
					message: chatInputValue || text,
				});
			}

			let payload = {
				id: state.conversationId,
				message:
					chatInputValue ||
					(text.trim().toLowerCase() === 'submit' ? '' : text),
				botId: loadStateSession('botId'),
				version: 'prod',
				country: loadStateSession('FS-country'),
				metaData: formData ? { ...formData } : {},
				userId: loadStateSession('userId'),
			};

			dispatch({ type: 'LOADING' });

			fetch(
				window['BASE_URL'] +
					(loadStateSession('message_api_url') ?? '/messages/'),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-tenant-id': loadStateSession('tenantId'),
						Authorization: `Bearer ${loadStateSession('token')}`,
					},
					body: JSON.stringify(payload),
				}
			)
				.then((data) => {
					if (data.status >= 500 && data.status < 600) {
						throw new Error('failed to fetch');
					}
					return data.json();
				})
				.then((response) => {
					if (response.status && response.status.toLowerCase() !== 'success') {
						throw new Error(response.message);
					}
					if (!response.status) {
						throw new Error(response.message);
					}
					if (response.status.toLowerCase() === 'success') {
						if (
							response.message.toLowerCase().indexOf('something went wrong') >
							-1
						) {
							dispatch({
								type: 'FAILED',
								chatMessages: [
									{
										type: 'server',
										message:
											'We are facing some technical issues in getting the result. Please try again',
										details: [],
										form: [],
									},
								],
							});
						} else {
							if (formData) {
								dispatch({
									type: 'USER_MESSAGE',
									message: chatInputValue || text,
								});
							}
							dispatch({
								type: 'SUCCESS',
								messageId: response.messageId,
								conversationId: response.id,

								chatMessages: [
									{
										type: 'server',
										message: response.message,
										details: response.metaData.details ?? [],
										form: response.metaData.form ?? [],

										messageId: response.messageId,
										suggestions: response.suggestions,
									},
								],
							});
							if (formData) {
								setSubmitLoader(false);
							}
						}
					}
				})
				.catch((error) => {
					dispatch({ type: 'LOADING' });
					let offlineMessage;

					if (error.message) {
						offlineMessage = error.message;
						if (error.message.toLowerCase() === 'failed to fetch') {
							offlineMessage = `Couldn't connect to the server. Please retry. If the issue persists, check your connection and try again later.`;
						}
					}

					if (!navigator.onLine) {
						dispatch({
							type: 'FAILED',
							chatMessages: [
								{
									type: 'server',
									message: 'Seems like you are not connected to a network.',
									details: [],
									form: [],
								},
							],
						});
					} else {
						dispatch({
							type: 'FAILED',
							chatMessages: [
								{
									type: 'server',
									message:
										offlineMessage.length > 0
											? offlineMessage
											: `Couldn't connect to the server. Please retry. If the issue persists, check your connection and try again later.`,
									details: [],
									form: [],
								},
							],
						});
					}
				});
			setChatInputValue('');
		}
	};

	useEffect(() => {
		if (chatContainerRef.current) {
			setTimeout(() => {
				chatContainerRef.current.scrollTo({
					top: chatContainerRef.current.scrollHeight,
					behavior: 'smooth',
				});
			}, 0);
		}
	}, [state.chatMessages]);

	useEffect(() => {
		dispatch({
			type: 'SUCCESS',
			chatMessages: [
				{
					type: 'server',
					message: conversationOpener,
					details: [],
					form: [],

					messageId: '',
				},
			],
		});
		function handleMessage(event) {
			console.log('Received Message');
			if (event.data.action === 'attachCloseListener_FF_Fratcal') {
				const closeSvgHolder = document.querySelector('#ff-close-svg-icon');
				console.log('came hrr');
				closeSvgHolder.addEventListener('pointerdown', () => {
					console.log('sent');
					window.parent.postMessage(
						{ action: 'close_FF_Iframe_Fractal' },
						event.origin
					);
				});
			}
		}
		window.addEventListener('message', handleMessage);
	}, []);
	return (
		<ChatscreenFractalTheme
			className='ff-fractal-theme-chatscreen'
			screenSize={screenSize}
			chatInputValue={chatInputValue}
		>
			<div>
				<div
					className={`conversation-holder ${deviceType} ${
						screenSize > 800 ? 'paddingInitial' : ''
					} `}
					id='fractal-conversation-holder'
					ref={chatContainerRef}
				>
					<Trending />
					{state.chatMessages.map((data, index) => {
						const isLastMessage = index === state.chatMessages.length - 1;
						return (
							<React.Fragment key={data.type + index}>
								<Message
									text={data.message}
									type={data.type}
									scrollId={`message-${data.type}-${index}`}
									deviceType={deviceType}
									suggestions={data.suggestions}
									submitChat={submitChat}
									form={data.form}
									submitLoader={submitLoader}
									setSubmitLoader={setSubmitLoader}
									allMessages={state.chatMessages}
									currentIndex={index}
									setFormIsActive={setFormIsActive}
									formIsActive={formIsActive}
									isLastMessage={isLastMessage}
								/>
								{data.type === 'server' &&
									(data.details.length > 0 || data.form.length > 0) && (
										<FractalResponse
											details={data.details}
											submitChat={submitChat}
											form={data.form}
										/>
									)}
							</React.Fragment>
						);
					})}
					{state.loader && !submitLoader && (
						<Message
							deviceType={deviceType}
							type={'server'}
							text={'loading'}
							scrollId={`message-server-loader`}
							suggestions={''}
							submitChat={submitChat}
							form={[]}
							submitLoader={submitLoader}
							setSubmitLoader={setSubmitLoader}
							allMessages={state.chatMessages}
							currentIndex={0}
							setFormIsActive={setFormIsActive}
							formIsActive={formIsActive}
							isLastMessage={0}
						/>
					)}
				</div>
			</div>
			{/* {formIsActive ? null : ( */}
			<div
				className={`close-svg-input-container ${
					formIsActive ? 'formIsActive' : ''
				}`}
			>
				{screenSize > 500 ? null : (
					<div
						style={{ cursor: 'pointer' }}
						className='close-svg-holder'
						id='ff-close-svg-icon'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='14'
							height='14'
							viewBox='0 0 14 14'
							fill='none'
						>
							<path
								id='close'
								d='M7.00001 8.05425L1.92701 13.1275C1.78851 13.2658 1.61443 13.3367 1.40476 13.34C1.19526 13.3432 1.01801 13.2723 0.873012 13.1275C0.728178 12.9825 0.655762 12.8068 0.655762 12.6005C0.655762 12.3942 0.728178 12.2185 0.873012 12.0735L5.94626 7.0005L0.873012 1.9275C0.734678 1.789 0.663845 1.61492 0.660512 1.40525C0.657345 1.19575 0.728178 1.0185 0.873012 0.8735C1.01801 0.728667 1.19368 0.65625 1.40001 0.65625C1.60635 0.65625 1.78201 0.728667 1.92701 0.8735L7.00001 5.94675L12.073 0.8735C12.2115 0.735167 12.3856 0.664333 12.5953 0.661C12.8048 0.657833 12.982 0.728667 13.127 0.8735C13.2718 1.0185 13.3443 1.19417 13.3443 1.4005C13.3443 1.60683 13.2718 1.7825 13.127 1.9275L8.05376 7.0005L13.127 12.0735C13.2653 12.212 13.3362 12.3861 13.3395 12.5958C13.3427 12.8053 13.2718 12.9825 13.127 13.1275C12.982 13.2723 12.8063 13.3448 12.6 13.3448C12.3937 13.3448 12.218 13.2723 12.073 13.1275L7.00001 8.05425Z'
								fill='#6E6E6E'
							/>
						</svg>
					</div>
				)}

				<Input
					autoFocus
					maxRows={2}
					multiline
					className='fractal-chat-input'
					placeholder={`Ask me anything`}
					value={chatInputValue}
					onChange={(e) => setChatInputValue(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !e.shiftKey) {
							if (chatInputValue.trim().length === 0) {
								e.preventDefault();
							} else {
								submitChat();
								e.preventDefault();
							}
						}
					}}
					endIcon={
						chatInputValue && (
							<div
								className='send-icon'
								style={{
									minHeight: screenSize > 500 ? '48px' : '33px',
									minWidth: screenSize > 500 ? '50px' : '33px',
									borderRadius: '50px',
									background: '#0174E7',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									cursor: 'pointer',
								}}
								onClick={() => submitChat()}
							>
								<svg
									style={{ marginLeft: '3px' }}
									xmlns='http://www.w3.org/2000/svg'
									width='25'
									height='25'
									viewBox='0 0 25 25'
									fill='none'
								>
									<g id='search'>
										<mask
											id='mask0_700_986'
											style={{ maskType: 'alpha' }}
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='25'
											height='25'
										>
											<rect
												id='Bounding box'
												x='0.5'
												y='0.5'
												width='24'
												height='24'
												fill='#D9D9D9'
											/>
										</mask>
										<g mask='url(#mask0_700_986)'>
											<g id='send'>
												<mask
													id='mask1_700_986'
													style={{ maskType: 'alpha' }}
													maskUnits='userSpaceOnUse'
													x='0'
													y='0'
													width='25'
													height='25'
												>
													<rect
														id='Bounding box_2'
														x='0.436523'
														y='0.560547'
														width='24'
														height='24'
														fill='#D9D9D9'
													/>
												</mask>
												<g mask='url(#mask1_700_986)'>
													<path
														id='send_2'
														d='M20.2365 13.4858L4.83652 19.9858C4.50319 20.1191 4.18652 20.0899 3.88652 19.8983C3.58652 19.7066 3.43652 19.4274 3.43652 19.0608V6.06076C3.43652 5.6941 3.58652 5.41493 3.88652 5.22326C4.18652 5.0316 4.50319 5.00243 4.83652 5.13576L20.2365 11.6358C20.6532 11.8191 20.8615 12.1274 20.8615 12.5608C20.8615 12.9941 20.6532 13.3024 20.2365 13.4858ZM5.43652 17.5608L17.2865 12.5608L5.43652 7.56076V11.0608L11.4365 12.5608L5.43652 14.0608V17.5608Z'
														fill='white'
													/>
												</g>
											</g>
										</g>
									</g>
								</svg>
							</div>
						)
					}
				/>
			</div>
		</ChatscreenFractalTheme>
	);
}
